import React, { useState } from 'react';

import { observer } from 'mobx-react-lite';

import Button from 'components/common/Button/Button';
import { EditIcon } from 'components/common/Icons/Icons';

import mainStyles from '../MyProfile.module.scss';
import styles from './EmailNotifications.module.scss';
import EmailNotificationsTable from './UserEmailNotificationsTable/UserEmailNotificationsTable';

const UserEmailNotifications = () => {
  const [isEdit, setIsEdit] = useState(false);

  return (
    <div className={mainStyles.mainContainer}>
      <div className={mainStyles.inputsContainer}>
        <div className={mainStyles.header}>
          <div className={mainStyles.headerLabel}>Email Notifications</div>
          {!isEdit && (
            <Button onClick={() => setIsEdit(true)} className={mainStyles.editButton} variant="link">
              <EditIcon /> Edit Notifications
            </Button>
          )}
        </div>
        <div className={styles.description}>
          Use the below table to choose which loan status emails you want to receive.
        </div>
        <EmailNotificationsTable isEdit={isEdit} handleCancelEdit={() => setIsEdit(false)} />
      </div>
    </div>
  );
};

export default observer(UserEmailNotifications);
